import AppContext from "PFApp/app_context";
import ProfileEditPage from "PFApp/profiles/edit/profile_edit_page";
import { adminProfileEditSections } from "PFApp/profiles/edit/profile_edit_sections";
import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { ApiRoute } from "PFCore/utilities/routes";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const EditUserController = () => {
  const [profile, setProfile] = useState(null);
  const [errors, setErrors] = useState(null);

  const { id, section = "details" } = useParams();

  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const handleProfileUpdate = (attributes = {}) => {
    const url = ApiRoute(`/api/admin/profiles/${id}`);
    const noUpdate = Object.keys(attributes).length === 0;

    return $.ajax({
      url,
      method: noUpdate ? "GET" : "PUT",
      api_version: 2,
      contentType: "application/json; charset=utf-8",
      data: noUpdate ? null : JSON.stringify(attributes)
    })
      .then((resp) => setProfile(resp))
      .catch(() => setErrors([true]));
  };

  useEffect(() => {
    handleProfileUpdate({});
  }, []);

  const WrappedProfileEditPage = usePageWrapper(ProfileEditPage);

  return (
    <WrappedProfileEditPage
      profile={profile}
      permissionsGroup={currentProfile.permissions_group}
      errors={errors}
      adminPage
      section={section}
      sections={adminProfileEditSections(profile)}
      handleProfileUpdate={handleProfileUpdate}
      loading={!errors && (!profile || !currentProfile.permissions_group)}
      errorComponent={
        <NotFoundComponent message={"It looks like you are trying to reach a profile that doesn't exist."} />
      }
    />
  );
};

export default EditUserController;
